export const isWujieSubApp = () => {
  /* eslint-disable no-underscore-dangle */
  return window.__POWERED_BY_WUJIE__;
};

export const emitMountedEvent = () => {
  if (!isWujieSubApp()) return;
  window.$wujie?.bus.$emit('mounted');
};
